import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSpinnerShow, getSpinnerText } from '../../VNLoader/Selectors'
import { setSpinner } from '../../VNLoader/ActionCreators'

const useSpinner = () => {
  const dispatch = useDispatch()
  const showSpinner = useSelector(getSpinnerShow)
  const spinnerText = useSelector(getSpinnerText)

  const startSpinner = useCallback(
    (text = '') => {
      dispatch(setSpinner(true, text))
    },
    [dispatch],
  )

  const stopSpinner = useCallback(() => {
    dispatch(setSpinner(false))
  }, [dispatch])

  return { startSpinner, stopSpinner, showSpinner, spinnerText }
}

export default useSpinner
